import { mapGetters } from 'vuex';
import { getAppData } from 'optinmonster-js-library/src/vue/utils';

export const marketingSso = {
	computed: {
		...mapGetters(['connected']),
	},
	methods: {
		marketingUrl(path = '', utmMedium = 'WordPressPlugin', utmContent = '') {
			if (this.connected) {
				return this.$urls.marketingSso(path, utmMedium);
			}

			let url = 0 === path.indexOf('http') ? path : this.$urls.marketing(`${path ? path + '/' : ''}`);

			const args = {
				utm_medium: utmMedium,
				utm_content: utmContent,
			};

			const partnerId = getAppData('partnerId');
			if (partnerId) {
				args.sscid = partnerId;
			}

			return this.$urls.utmLink(url, args);
		},
	},
};
